import "./main.scss";
import culture from "jsl-ui/lib/core/culture";
import { JSLRender } from "jsl-render";
import { JSLRoute } from "jsl-route";
import { SearchTokenComponent } from "./components/service/SearchTokenComponent";
import { StatusComponent } from "./components/service/StatusComponent";
import { ErrorComponent } from "./components/common/ErrorComponent";
import { LayoutComponent } from "./components/common/LayoutComponent";
import { GarantieVerlaengerungComponent } from "./components/landing/deprecated/GarantieVerlaengerungComponent";
import { GarantieVerlaengerungComponent9er } from "./components/landing/deprecated/GarantieVerlaengerungComponent9er";
import { SommerPageComponent } from "./components/landing/sommer/SommerPageComponent";
import { ChilledPageComponent } from "./components/landing/chilled/ChilledPageComponent";
import { LandingPageComponent } from "./components/landing/LandingPageComponent";
import { LandingController } from "./ajax/LandingController";
import { LoadingComponent } from "jsl-ui";
import { MoelkPageComponent } from './components/landing/moelk/MoelkPageComponent';
import { StatusGarantieComponent } from './components/landing/StatusGarantieComponent';

culture.set("de");

// const regex: RegExp = new RegExp('.+');

const renderer = new JSLRender(document.body, true);

const routes = {

    "": () => {
        JSLRoute.navigate("search");
    },

    /* service portal routes */
    "status": (parameters) => {
        if (parameters.length === 0) {
            renderer.render(new LayoutComponent(new ErrorComponent("")));
        } else if (parameters[0] === "") {
            renderer.render(new LayoutComponent(new ErrorComponent("")));
        } else {
            renderer.render(new LayoutComponent(new StatusComponent(parameters[0])));
        }
    },
    "error": () => {
        renderer.render(new LayoutComponent(new ErrorComponent("")));
    },
    "search": () => {

        if (location.href.toLocaleLowerCase().startsWith("https://office.nivona.online")) {
            JSLRoute.navigate("#garantie");
        }
        // else if (location.href.toLocaleLowerCase().startsWith("https://starterset.nivona.online")) {
        //     JSLRoute.navigate("#starterset");
        // }
        // else if (location.href.toLocaleLowerCase().startsWith("https://garantie823.nivona.online")) {
        //     JSLRoute.navigate("#garantie823");
        // }
        else if (location.href.toLocaleLowerCase().startsWith("https://sorgenfrei.nivona.online")) {
            JSLRoute.navigate("#wertgarantie25");
        }
        else if (location.href.toLocaleLowerCase().startsWith("https://ausgezeichnet.nivona.online")) {
            JSLRoute.navigate("#ausgezeichnet");
        } else if (location.href.toLocaleLowerCase().startsWith("https://sicheristsicher.nivona.online")) {
            JSLRoute.navigate("#wertgarantie26");
        }
        // else if (location.href.toLocaleLowerCase().startsWith("https://sommer.nivona.online")) {
        //     LandingController.GetLandingForm("sommer").then((form) => {
        //         if (form != null) {
        //             renderer.render(new SommerPageComponent(form));
        //         } else {
        //             alert("Error - Aktion ausgelaufen");
        //         }
        //     }).catch((e) => {
        //         console.log(e);
        //         renderer.render(new LayoutComponent(new ErrorComponent("Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut")));
        //     });
        // } else if (location.href.toLocaleLowerCase().startsWith("https://chilled.nivona.online")) {
        //     LandingController.GetLandingForm("chilled").then((form) => {
        //         if (form != null) {
        //             renderer.render(new ChilledPageComponent(form));
        //         } else {
        //             alert("Error - Aktion ausgelaufen");
        //         }
        //     }).catch((e) => {
        //         console.log(e);
        //         renderer.render(new LayoutComponent(new ErrorComponent("Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut")));
        //     });
        // }
        else if (location.href.toLocaleLowerCase().startsWith("https://starter.nivona.online"))
            {
            LandingController.GetLandingForm("mölk").then((form) => {
                if (form != null) {
                    renderer.render(new MoelkPageComponent(form));
                } else {
                    alert("Error - Aktion ausgelaufen");
                }
            }).catch((e) => {
                console.log(e);
                renderer.render(new LayoutComponent(new ErrorComponent("Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut")));
            });
        } else {
            renderer.render(new LayoutComponent(new SearchTokenComponent()));
        }
    },

    /* deprecated landing page routes */
    "garantie": () => { // Büropaket
        renderer.render(new LayoutComponent(new GarantieVerlaengerungComponent()));
    },
    // "starterset": () => {
    //     renderer.render(new LayoutComponent(new GarantieVerlaengerungComponent9er()));
    // },

    "sucessGarantie": (params) => {
        renderer.render(new LayoutComponent(new StatusGarantieComponent(params[0])));
    }
    // ,
    // "try": () => {
    //     renderer.render(new LayoutComponent(new GarantieVerlaengerungTryComp()))
    // }
};

renderer.render(new LoadingComponent(4));

JSLRoute.setup(routes, async (name) => {

    if (location.hash.length > 1) {
        // check if this hash is a valid landing page - otherwise 404 error
        try {
            const form = await LandingController.GetLandingForm(name);
            if (form != null) {
                renderer.render(new LayoutComponent(new LandingPageComponent(form)));
            } else {
                renderer.render(new LayoutComponent(new ErrorComponent("Diese Seite existiert leider nicht mehr")));
            }
        } catch (e) {
            console.log(e);
            renderer.render(new LayoutComponent(new ErrorComponent("Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut")));
        }
    }
});
